import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import AOS from "aos"
import "aos/dist/aos.css"
import './assets/sass/app.scss'
import 'materialize-css/sass/materialize.scss'
import VueNumber from "vue-number-animation";

Vue.use(VueNumber);
Vue.config.productionTip = false
window.axios = axios.create({
  baseURL: window.baseURL
})
Vue.prototype.$http = window.axios
Vue.prototype.$store = store



new Vue({
  created(){
    AOS.init();
  },
  router,
  render: h => h(App)
}).$mount('#app')
